import { ColumnProps } from "antd/lib/table";

import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { IStore } from "../../../models/store/response";
import Space from "../../general/antd/space";
import DeleteBtn from "../../general/table-components/actions/delete-btn";
import eventManager, { EVENT_SUCCESS } from "../../../utils/events";
import { ISort, IStaticFilter } from "../../../models/base/base-query";
import { tableOnChange } from "../../../utils/helpers/table-sorts-filters";
import Table from "../../general/table-components/table";

import Tag from "../../general/antd/tag";
import moment from "moment";
import FormHookModal from "../../general/modals/form-hook-modal";
import { useModal } from "react-modal-hook";
import CopyForm from "../copy-form";
import PrizeForm from "../prize-form";
import PrizeContext from "../../../context/prize/context";
import StoreJoinRequestContext from "../../../context/store-join-request/context";

interface IProps {}

const StoreJoinRequestTable: React.FC<IProps> = (props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { list, actions, loading, query } = useContext(StoreJoinRequestContext);
  const {
    actions: actionPrize,
    loading: loadingPrize,
    query: queryPrize,
  } = useContext(PrizeContext);
  const [infoId, setInfoId] = useState<number>();
  const [showFormModal, hideForModal] = useModal(
    () => (
      <FormHookModal
        id="4"
        confirmButtonText={t("save")}
        loading={
          loading.includes("create") ||
          loading.includes("details") ||
          loading.includes("update")
        }
        title={t("copy_products_to")}
        hideModal={() => {
          hideForModal();
          setInfoId(undefined);
         // actions.setDetails(undefined);
        }}
        width={"50vw"}
        style={{
          marginTop: "1.6rem",
          height: "59vh",
        }}
        onSubmit={async (data) => {
          // await actions.copyStoreProducts({
          //   firstStoreId: infoId,
          //   secondStoreId: data?.secondStoreId,
          // });
         // setInfoId(undefined);
        }}
        defaultValues={{ secondStoreId: 1 }}
      >
        <CopyForm />
      </FormHookModal>
    ),
    [loading, infoId]
  );

  const [showAddPrizeModal, hideAddPrizeModal] = useModal(
    () => (
      <FormHookModal
        id="4"
        confirmButtonText={t("save")}
        loading={loadingPrize.includes("create")}
        title={t("add_prize_to")}
        hideModal={() => {
          hideAddPrizeModal();
          setInfoId(undefined);
         // actions.setDetails(undefined);
        }}
        width={"50vw"}
        style={{
          marginTop: "1.6rem",
          height: "59vh",
        }}
        onSubmit={async (data) => {
          await actionPrize.createPrize({
            storeId: infoId,
            ...data,
          });
          setInfoId(undefined);
        }}
      >
        <PrizeForm />
      </FormHookModal>
    ),
    [loading, infoId]
  );

  const columns: ColumnProps<IStore>[] = [
    {
      title: t("id"),
      dataIndex: "id",
      key: "id",
      sorter: {
        multiple: 1,
      },
      width: 50,
      align: "center",
    },

    {
      title: t("name"),
      dataIndex: "pharmacy_name",
      align: "center",
      key: "pharmacy_name",
      width: 100,
      sorter: {
        multiple: 2,
      },
    },
    {
      title: t("pharmacist_name"),
      dataIndex: "pharmacist_name",
      align: "center",
      key: "pharmacist_name",
      width: 100,
      sorter: {
        multiple: 2,
      },
    },
    {
      title: t("location"),
      dataIndex: "location",
      align: "center",
      key: "location",
      width: 200,
      sorter: {
        multiple: 2,
      },
    },
   
    {
      title: t("phone"),
      dataIndex: "mobile",
      align: "center",
      key: "mobile",
      width: 100,
    },
   
 
    {
      title: t("created_at"),
      dataIndex: "createdAt",
      align: "center",
      key: "createdAt",
      width: 200,
      sorter: {
        multiple: 3,
      },
      render: (_, record) => {
        return moment(record?.createdAt).format("YYYY-MM-DD");
      },
    },
    {
      title: t("actions"),
      width: 50,
      dataIndex: "",
      fixed: "right",
      align: "center",
      key: "x",
      render: (_: any, record) => (
        <Space>
        
          
          <DeleteBtn
            onConfirm={async () => {
              await actions.deleteStoreJoinRequest(record?.id);
              eventManager.emit(EVENT_SUCCESS);
            }}
            loading={loading.includes("delete")}
          />
        </Space>
      ),
    },
  ];

  // Filters && Sorts
  let tableFiltersProps = {};
  const [sorts, setSorts] = useState<ISort[]>([]);
  const [, setStaticFilters] = useState<IStaticFilter[]>(query?.filters ?? []);

  useEffect(() => {
    sorts.length > 0 &&
      actions.setQuery({
        ...query,
        orders: sorts,
      });
  }, [sorts]);

  return (
    <>
      <Table<any>
        rowKey="id"
        showPagination={true}
        columns={columns}
        dataSource={list?.data ?? []}
        loading={loading.includes("list")}
        size="small"
        total={list?.total}
        pageSize={query.perPage}
        page={query.page}
        scroll={{
          x: 1300,
        }}
        onPaginationChange={(page, pageSize) => {
          actions.setQuery({
            ...query,
            page,
            perPage: pageSize,
          });
        }}
        onChange={(_, tableFilters, tabelSorters) => {
          tableOnChange(
            tableFilters,
            tabelSorters,
            tableFiltersProps,
            setSorts,
            setStaticFilters
          );
        }}
      />
    </>
  );
};

export default StoreJoinRequestTable;
